interface Props {
  children: React.ReactNode;
}

export const Container = ({ children }: Props) => {
  return (
    <div className="m-auto box-border w-full max-w-screen-2xl px-8">
      {children}
    </div>
  );
};
